// Preact
// eslint-disable-next-line no-unused-vars
import { Fragment, h } from 'preact';
import { useContext, useEffect, useRef } from 'preact/hooks';
import PropTypes from 'prop-types';
import { SearchContext } from '../contexts/Search';

/**
 * The main component.
 *
 * @param {Object} props Props
 * @return {Object} JSX
 */
const Post = ( props ) => {
	const { state } = useContext( SearchContext );
	const { loading, focusNewPost, focusPostId, sectionName } = state;
	const { post } = props;
	const { data } = post;
	const { ID } = data;
	const ref = useRef( null );

	let postWrapperClassName = 'border-top py-4';

	if (sectionName === 'research-forum') {
		postWrapperClassName = '';
	}

	useEffect( () => {
		if ( focusPostId === ID && focusNewPost && !loading ) {
			ref.current.querySelector( 'a' ).focus();
		}
	}, [loading, focusNewPost, focusPostId, ID] );

	// eslint-disable-next-line react/no-danger
	return <div className={postWrapperClassName} ref={ref} dangerouslySetInnerHTML={{ __html: post.markup }} />;
};

Post.propTypes = {
	post: PropTypes.shape( {
		data: PropTypes.shape( {
			ID: PropTypes.number.isRequired,
		} ),
		markup: PropTypes.string.isRequired,
	} ).isRequired,
};

export default Post;
